// extracted by mini-css-extract-plugin
module.exports = {"checkbox-group":"a2c79c7e7d--checkbox-group--KITrL","divider":"a2c79c7e7d--divider--ouuGh"};